import { metricsManager as globalsMetricsManager } from "../Globals";
import { config } from "../config";
import { Logger } from "../Logger";
import { MediaInterruptionMetricsCollector } from "./MediaInterruptionMetricsCollector";
import { VideoClientMetricsCollector } from "./VideoClientMetricsCollector";
import { WebrtcConnectionStateMetricsCollector } from "./WebrtcConnectionStateMetricsCollector";
import { InboundBandwidthFulfillmentMetricsCollector } from "./InboundBandwithFulfillmentMetricsCollector";
import { rootEventEmitter } from "../EventEmitter/GVCEventEmitter";
class MetricsManager {
    static instance = new MetricsManager();
    vc = new VideoClientMetricsCollector(rootEventEmitter);
    mediaInterruption = new MediaInterruptionMetricsCollector();
    connectionState = new WebrtcConnectionStateMetricsCollector();
    inboundBandwidthFulfillment = new InboundBandwidthFulfillmentMetricsCollector();
    collectors = [
        this.vc,
        this.mediaInterruption,
        this.connectionState,
        this.inboundBandwidthFulfillment,
    ];
    _uploadMetricsInterval;
    _overrideMetricsOutput = false;
    constructor() {
        this.startCollection();
        this._uploadMetricsInterval = window.setInterval(this.uploadMetrics, config.metricsUploadRateMS);
    }
    startCollection() {
        this.collectors.forEach((collector) => {
            collector.start();
            collector.resetCollection();
        });
    }
    stopCollection() {
        this.collectors.forEach((collector) => collector.stop());
    }
    uploadMetrics = () => {
        let allMetrics = [];
        this.collectors.map((collector) => {
            const metrics = collector.outputMetrics();
            collector.resetCollection();
            allMetrics = allMetrics.concat(metrics);
        });
        const sendMetric = (metric) => {
            const metricsOutput = this._overrideMetricsOutput ? "newrelic" : config.metricsOutput;
            switch (metricsOutput) {
                case "console": {
                    Logger.log(`${metric.name} metrics:`, metric.values);
                    break;
                }
                case "newrelic": {
                    globalsMetricsManager.addMetricReliably(metric.name, metric.values);
                    break;
                }
            }
        };
        allMetrics.forEach((metric) => sendMetric(metric));
    };
    stopInterval() {
        clearInterval(this._uploadMetricsInterval);
    }
    startInterval(overrideMetricsOutput = false) {
        this._overrideMetricsOutput = overrideMetricsOutput;
        this._uploadMetricsInterval = window.setInterval(this.uploadMetrics, config.metricsUploadRateMS);
    }
}
export const metricsManager = MetricsManager.instance;
//# sourceMappingURL=MetricsManager.js.map